export const formatAsTwoDigits = (input: number): string => {
  if (input < 10) return `0${input}`
  return input.toString()
}

export const formatDecimals = (input: number | string, decimals: number) => {
  const number = parseFloat(input.toString())
  if (Number.isNaN(number)) {
    return "NaN"
  }

  return number.toFixed(decimals)
}

export const formatPercentage = (val: number, decimals = 0): string => {
  return `${(val * 100).toFixed(decimals)}%`
}

export const formatNumber = (val: number | string, options: any = {}) => {
  const number = parseFloat(val.toString())

  if (Number.isNaN(number)) {
    return ""
  }

  const formatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
    ...options
  })

  return formatter.format(number)
}

/**
 * Converts a number to a USD currency formatted string.
 *
 * @param {number | string} value - The number to format.
 * @param {boolean} noDecimals - Whether to format without decimals.
 * @param {number} [maximumSignificantDigits] - The maximum number of significant digits.
 * @returns {string} - The formatted USD currency string.
 */
export const numberToUSD = (
  value: number | string = 0,
  noDecimals = true,
  maximumSignificantDigits?: number
) => {
  // if value is a string, convert it to a number
  if (typeof value === "string") {
    value = parseFloat(value)
  }

  const options: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "USD"
  }
  const num = Number(noDecimals ? value.toFixed() : value)
  if (noDecimals) {
    const n = value.toFixed()
    const l = (n + "").length
    options.maximumSignificantDigits = l
  } else if (maximumSignificantDigits) {
    options.maximumSignificantDigits = maximumSignificantDigits
  }
  return new Intl.NumberFormat("en-US", options).format(num)
}
